export default {
  name: "turntable",
  imgDir: "turntableLottery",
  actConfig:{
    turntable: {
      projectId: "61",
      projectName: "佘山项目",
      actName: "模板预览",
      startTime: 1641484800000,
      endTime: 1642175999000,
      gpsSwitch: 0,
      couponSwitch: 1,
      rankPrizeSwitch: 1,
      watchShowSwitch: 1,
      joinShowSwitch: 1,
      rotationWinSwitch: 1,
      actRule:
        "<p><strong>活动说明：</strong></p>\n<p>文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容</p>\n<p><strong>活动时间：</strong></p>\n<p>文字内容文字内容文字内容文字内容</p>\n<p><strong>领奖时间：</strong></p>\n<p>文字内容文字内容文字内容文字内容</p>\n<p><strong>优惠券规则：</strong></p>\n<p>文字内容文字内容文字内容文字内容</p>\n<p><strong>排行榜时间：</strong></p>\n<p>文字内容文字内容文字内容文字内容</p>",
      disclaimer: "本次活动最终解释权归开发商所有。",
      backgroundMusicSwitch: 1,
      backgroundMusicUrl: "http://assets.rurushishi.com/activies/rchd-blind-box-2021-11/bgm.mp3",
      backgroundColour: "#B70110",
      mainColour: "#EF1350",
      buttonBackgroundColour: "#F3A92B",
      buttonTextColour: "#FFFFFF",
      popupBackgroundColour: "#FFFFFF",
      backgroundImg: "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/bg.png",
      topLogoImg: "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/logo.png",
      mainKvImg: "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/kv.png",
      wheelBackgroundImg: "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/lotteryBg.png",
      wheelBaseImg: "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/lotteryBg2.png?v=20220120",
      wheelPointerImg: "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/lotteryPointer.png",
      wheelButtonImg: "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/draw.png",
      shareButtonStyleImg: "",
      popupStyleImg: "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/prizeImg.png",
      shareSwitch: 1,
      shareTitle: "分享标题",
      shareInfo: "分享描述",
      shareImg: 'https://assets.rurushishi.com/activies/activityCenter/turntableLottery/poster.jpg',
      shareSmallImg: 'https://assets.rurushishi.com/activies/activityCenter/turntableLottery/shareIcon.jpg',
      couponTitle: "购房优惠券",
      rankPrizeTitle: "排行榜奖品",
      prizeTitle: "奖品展示",
      salesSiteTitle: "项目展示",
      status: 1,
      receiveAddress: '["这是第一个领奖地址"]',
      lotteryTimesLimitSwitch: 0,
      lotteryTimesDailyLimit: 1,
    },
    blindbox:{
      projectId: "61",
      projectName: "佘山项目",
      actName: "模板预览",
      startTime: 1641484800000,
      endTime: 1642175999000,
      gpsSwitch: 0,
      couponSwitch: 1,
      rankPrizeSwitch: 1,
      watchShowSwitch: 1,
      joinShowSwitch: 1,
      rotationWinSwitch: 1,
      actRule:
        "<p><strong>活动说明：</strong></p>\n<p>文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容</p>\n<p><strong>活动时间：</strong></p>\n<p>文字内容文字内容文字内容文字内容</p>\n<p><strong>领奖时间：</strong></p>\n<p>文字内容文字内容文字内容文字内容</p>\n<p><strong>优惠券规则：</strong></p>\n<p>文字内容文字内容文字内容文字内容</p>\n<p><strong>排行榜时间：</strong></p>\n<p>文字内容文字内容文字内容文字内容</p>",
      disclaimer: "本次活动最终解释权归开发商所有。",
      backgroundMusicSwitch: 1,
      backgroundMusicUrl: "http://assets.rurushishi.com/activies/rchd-blind-box-2021-11/bgm.mp3",
      backgroundColour: "#71544E",
      mainColour: "#F9AB10",
      buttonBackgroundColour: "#EC3551",
      buttonTextColour: "#FFFFFF",
      popupBackgroundColour: "#FFFFFF",
      backgroundImg: "https://assets.rurushishi.com/activies/activityCenter/blindboxLottery/bg.png",
      topLogoImg: "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/logo.png",
      mainKvImg: "https://assets.rurushishi.com/activies/activityCenter/blindboxLottery/kv.png",
      wheelBackgroundImg: "https://assets.rurushishi.com/activies/activityCenter/blindboxLottery/lotteryBg.png",
      wheelBaseImg: "https://assets.rurushishi.com/activies/activityCenter/blindboxLottery/lotteryBg2.png?v=20220120",
      wheelPointerImg: "https://assets.rurushishi.com/activies/activityCenter/blindboxLottery/lotteryPointer.png",
      wheelButtonImg: "https://assets.rurushishi.com/activies/activityCenter/blindboxLottery/draw.png",
      shareButtonStyleImg: "",
      popupStyleImg: "https://assets.rurushishi.com/activies/activityCenter/blindboxLottery/prizeImg.png",
      shareSwitch: 1,
      shareTitle: "分享标题",
      shareInfo: "分享描述",
      shareImg: 'https://assets.rurushishi.com/activies/activityCenter/blindboxLottery/poster.jpg',
      shareSmallImg: 'https://assets.rurushishi.com/activies/activityCenter/blindboxLottery/shareIcon.jpg',
      couponTitle: "购房优惠券",
      rankPrizeTitle: "排行榜奖品",
      prizeTitle: "奖品展示",
      salesSiteTitle: "项目展示",
      status: 1,
      receiveAddress: '["这是第一个领奖地址"]',
      lotteryTimesLimitSwitch: 0,
      lotteryTimesDailyLimit: 1,
    }
  }
};
